import { Button } from "@/components/shadcn/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/shadcn/dialog";

import { Model, ModelList } from "@/pages/chatbot/ai_settings/ModelList.tsx";
import { useTranslation } from "react-i18next";
import {
  ModelCard,
  ModelCardProps,
} from "@/pages/chatbot/ai_settings/ModelCard.tsx";
import { modelsListQuery } from "@/store/models.ts";
import Loading from "@/components/Loading";
import React, { useEffect } from "react";

interface ModelModalProps {
  selectedModelID: string | null;
  onModelChange: (model: Model) => void;
  ModelCardComponent?: React.FC<ModelCardProps>;
}

export function ModelModal({
  selectedModelID,
  onModelChange,
  ModelCardComponent,
}: ModelModalProps) {
  const { t } = useTranslation();
  const modelsQuery = modelsListQuery();

  const [selectedModel, setSelectedModel] = React.useState<Model | null>(null);
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    if (modelsQuery.data as Model[]) {
      setSelectedModel(
        modelsQuery.data.find((model: Model) => {
          return (
            model.id == selectedModelID ||
            model.id == `openai/${selectedModelID}`
          );
        }),
      );
    }
  }, [modelsQuery.data, selectedModelID]);

  if (modelsQuery.isLoading) {
    return <Loading />;
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger className="w-full text-left mb-4">
        {!ModelCardComponent && selectedModel && <ModelCard model={selectedModel} showDesc={false} />}
        {ModelCardComponent && selectedModel && (
          <ModelCardComponent model={selectedModel} showDesc={false} />
        )}
        {!selectedModel && (
          <Button variant="outline">{t("models.select_model")}</Button>
        )}
      </DialogTrigger>
      <DialogTitle></DialogTitle>
      <DialogContent
        className="modal-sizing"
        onOpenAutoFocus={(e: CustomEvent) => {
          e.preventDefault();
        }}
      >
        <DialogHeader>
          <DialogDescription></DialogDescription>
        </DialogHeader>

        <ModelList
          models={modelsQuery.data}
          onModelChange={(model) => {
            setOpen(false);
            onModelChange(model);
          }}
        />

        <DialogFooter></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
